import axios from 'axios'
import { useEffect, useState } from 'react'
import styles from './log.module.css'

const Log = ({ title }) => {
    const [data, setData] = useState([])
    const [message, setMessage] = useState()
    const fetchlogs = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/logs/${title}`,
                { withCredentials: true }
            )
            console.log(response.data)
            if (response.data.lo.length > 0) {
                console.log(response.data)
                setData(response.data.lo)
            }
        } catch (error) {
            console.log(error)
            setMessage(error?.response?.data?.message || 'Something went wrong')
        }
    }

    useEffect(() => {
        fetchlogs()
    }, [title])

    function formatLabel(str) {
        if (!str) return '';

        // Insert space before capital letters (excluding the first)
        const withSpaces = str.replace(/([a-z])([A-Z])/g, '$1 $2');

        // Capitalize first letter
        const rmovespace = withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
        return rmovespace.replace(/_/g, ' ')

    }


    return (
        <div
            className={styles.contain}
        >
            <h2 className={styles.head}>
                {title.replace(/_/g, ' ')}
            </h2>
            <div className={styles.containe}>
                {message && <div className={styles.message}>{message}</div>}
                {data?.map((log, index) => (
                    <div key={index} className={styles.actions}>
                        {/* <h3 className={styles.head}>Log #{index + 1}</h3> */}

                        {
                            Object.keys(log.data).map((key) => (
                                <span key={key} className={styles.head}>
                                    <strong className={styles.head}>{formatLabel(key)}:</strong>
                                    <span className={styles.head}>{log.data[key] ?? "null"}</span>
                                </span>
                            ))
                        }
                        <span className={styles.head}>
                            <strong>Created At:</strong>
                            <span>
                                {new Date(log.metadata?.created_at).toLocaleDateString()},
                                {new Date(log.metadata?.created_at).toLocaleTimeString([], {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                })}
                            </span>
                        </span>


                        {/* <span className={styles.head}><strong>Created At:</strong> <span>{new Date(log.metadata?.created_at).toLocaleString()}</span></span> */}
                        <span className={styles.head}><strong>By:</strong>
                            <span className={styles.last}>

                                {typeof log.metadata?.created_by === 'string'
                                    ? log.metadata?.created_by
                                    : `${log.metadata?.created_by?.name} (${log.metadata?.created_by?.role})`}
                            </span>
                        </span>
                    </div>
                ))}
            </div>

        </div>
    )
}

export default Log